<template>
    <div class="layout-wrapper">
        <div class="container-fluid">
            <div class="col-12">
                <div class="card shadow">
                    <div class="card-header bg-accent-grad glow-accent text-center">
                        <h4 class="text-white mb-0">ویرایش اطلاعات کاربری</h4>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <!--<div class="col-12 text-center">-->
                            <!--<div class="profile-image">-->
                            <!--<img :src="userModel.userNewImage" class="img-fluid" v-if="newImageCliked">-->
                            <!--<img :src="userModel.userImage" class="img-fluid" v-else>-->
                            <!--</div>-->
                            <!--<input type="file" id="fileUpload" class="d-none"-->
                            <!--@change="onProfileImageChange($event)">-->
                            <!--<label for="fileUpload" class="btn btn-info btn-round mb-3 clickable">بارگذاری-->
                            <!--تصویر</label>-->
                            <!--</div>-->
                            <div class="col-lg-4 mb-4">
                                <div class="input-group round">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">نام</span>
                                    </div>
                                    <input class="form-control" disabled v-model="userModel.firstName">
                                </div>
                            </div>
                            <div class="col-lg-4 mb-4">
                                <div class="input-group round">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">نام خانوادگی</span>
                                    </div>
                                    <input class="form-control" disabled v-model="userModel.lastName">
                                </div>
                            </div>
                            <div class="col-lg-4 mb-4">
                                <div class="input-group round">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">نام پدر</span>
                                    </div>
                                    <input class="form-control" v-model="userModel.fatherName">
                                </div>
                            </div>

                            <div class="col-lg-4 mb-4">
                                <div class="input-group round">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">تاریخ تولد</span>
                                    </div>
                                    <date-picker type="date" format="jYYYY/jMM/jDD" @input="onCreateDatePicked"
                                                 ref="birthDay" style="flex: 1">
                                        <slot>
                                            <input v-model="birthDay"
                                                   class="form-control date-input flex-grow-1" readonly="true"
                                                   @click="toggleCreateDatePicker">
                                        </slot>
                                    </date-picker>
                                </div>
                            </div>
                            <div class="col-lg-4 mb-4">
                                <div class="input-group round">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">محل تولد</span>
                                    </div>
                                    <input class="form-control" v-model="userModel.birthplace">
                                </div>
                            </div>
                            <div class="col-lg-4 mb-4">
                                <div class="input-group round">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">کد ملی</span>
                                    </div>
                                    <input class="form-control" disabled v-model="userModel.nationalCode">
                                </div>
                            </div>

                            <div class="col-lg-4 mb-4">
                                <div class="input-group round">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">شماره تلفن همراه</span>
                                    </div>
                                    <input class="form-control" disabled v-model="userModel.cellPhone1">
                                </div>
                            </div>
                            <div class="col-lg-4 mb-4">
                                <div class="input-group round">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">شماره تلفن ثابت</span>
                                    </div>
                                    <input class="form-control" type="number" v-model="userModel.phone1">
                                </div>
                            </div>
                            <div class="col-lg-4 mb-4">
                                <div class="input-group round">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">کد پستی</span>
                                    </div>
                                    <input class="form-control" type="number" v-model="userModel.postalCode">
                                </div>
                            </div>

                            <div class="col-lg-12 mb-4">
                                <div class="input-group round">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">آدرس</span>
                                    </div>
                                    <input class="form-control" v-model="userModel.address">
                                </div>
                            </div>

                            <div class="col-lg-6 mb-4">
                                <div class="input-group round">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">شماره حساب بانکی</span>
                                    </div>
                                    <input class="form-control" type="number" v-model="userModel.accountNumber">
                                </div>
                            </div>
                            <div class="col-lg-12 mb-4">
                                <div class="input-group round">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">شماره شبا حساب بانکی</span>
                                    </div>
                                    <input class="form-control" type="text" v-model="userModel.shebaCode">
                                </div>
                            </div>

                            <div class="col-lg-12 text-center my-4">
                                <button class="btn btn-primary btn-round" @click="submitUserForm">ثبت اطلاعات</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--///////////////////////////////////////////////////////////////////////////////////////////////////-->
            <!--<modal show="false" ref="insertModal">-->
                <!--<div class="row">-->
                    <!--<div class="col-12 text-center">-->
                        <!--<h1 v-if="netMode === 'create'">ثبت شبکه اجتماعی</h1>-->
                        <!--<h1 v-else>ویرایش شبکه اجتماعی</h1>-->
                    <!--</div>-->
                    <!--<div class="col-lg-6 offset-lg-3 mb-4">-->
                        <!--<div class="input-group round">-->
                            <!--<div class="input-group-prepend">-->
                                <!--<span class="input-group-text">نام شبکه اجتماعی</span>-->
                            <!--</div>-->
                            <!--<vs-select @onSearch="onDropDownFocused" @onSearchBlurred="onDropDownBlurred"-->
                                       <!--:data="netTypes" :mode="'create'"-->
                                       <!--:selected-val="value"-->
                                       <!--:header="{multiple: false, label: 'title'}"-->
                                       <!--aria-placeholder="نام شبکه اجتماعی"-->
                                       <!--@onChange="onNetTypeChange">-->

                            <!--</vs-select>-->
                        <!--</div>-->
                    <!--</div>-->
                    <!--<div class="col-lg-6 offset-lg-3 mb-4">-->
                        <!--<div class="input-group round mb-2">-->
                            <!--<div class="input-group-prepend">-->
                                <!--<span class="input-group-text">شماره</span>-->
                            <!--</div>-->
                            <!--<input class="form-control" v-model="model.number">-->
                        <!--</div>-->
                        <!--<div class="input-group round mb-2">-->
                            <!--<div class="input-group-prepend">-->
                                <!--<span class="input-group-text">لینک</span>-->
                            <!--</div>-->
                            <!--<input class="form-control" v-model="model.urlLink">-->
                        <!--</div>-->

                    <!--</div>-->
                    <!--<div class="col-lg-6 offset-lg-3 text-center">-->
                        <!--<label class="btn btn-primary btn-round clickable mt-3"-->
                               <!--@click="updateNet" v-if="netMode=='edit'">ویرایش شبکه اجتماعی</label>-->
                        <!--<label class="btn btn-primary btn-round clickable mt-3"-->
                               <!--@click="createNet" v-else>ثبت شبکه اجتماعی</label>-->
                        <!--<label class="btn btn-success btn-round clickable mt-3 mx-3"-->
                               <!--@click="cancelNet">انصراف</label>-->
                    <!--</div>-->
                <!--</div>-->
            <!--</modal>-->
        </div>
    </div>
</template>

<script>
    import BaseService from "../_framework/api/BaseService";
    import Moment from 'moment-jalali';
    import DatePicker from '../_framework/vue-persian-datetime-picker/VuePersianDatetimePicker.vue';
    import VsSelect from "../_framework/VsSelect";
    import Utils from "../_framework/utils/Utils";
    import EventBus from "../_framework/event-bus";

    export default {
        name: "profile",
        components: {VsSelect, DatePicker},
        data() {
            return {
                userModel: {

                    id: 0,
                    firstName: "",
                    lastName: "",
                    fatherName: "",
                    birthdate: "2020-11-13T14:51:43.919Z",
                    birthplace: "",
                    nationalCode: "",
                    cellPhone1: "",
                    phone1: "",
                    postalCode: "",
                    address: "",
                    accountNumber: "",
                    shebaCode: "",
                    code: "",

                    // birthCertificate: "",
                    // userName: "",
                    // mobile: "",
                    // city: "",
                    // cityId: 0,
                    // province: "",
                    // provinceId: 0,
                    // userImage: "",
                    // userNewImage: "",
                    // email: "",
                    // extension: "",
                    // mainJob: "",


                },
                preselectedUserGender: {},
                preselectedUserProvince: {},
                preselectedUserCity: {},
                userGender: [
                    {
                        name: "مرد",
                        value: true
                    },
                    {
                        name: "زن",
                        value: false
                    }
                ],
                city: [],
                province: [],
                isLoading: false,
                birthDay: "",
                newImageCliked: false,
                myNets: [],
                model: {
                    id: 0,
                    number: "",
                    urlLink: "",
                    type: 1,
                },
                netTypes: [],
                netIcons: [],
                netMode: "",


            }
        },
        mounted() {
            // this.getnetTypes();
            // this.getnetIcons();
            this.getUserData();
            // console.log("sa;alknkmnlk")
            // this.getProvince();
            // this.userModel.userImage = this.validateProfilePlaceholder(this.validateImageUrl(this.validateProfileImage(this.userModel.userImage)));
            this.userModel.userImage = this.validateImageUrl(this.userModel.userImage);
            // this.getMyNets();

        },
        methods: {
            getUserData() {
                this.isLoading = true;
                new BaseService("Profile").getList().then(response => {
                    this.isLoading = false;

                    this.userModel.id = response.data.data.id;
                    this.userModel.firstName = response.data.data.firstName;
                    this.userModel.lastName = response.data.data.lastName;
                    this.userModel.fatherName = response.data.data.fatherName;
                    this.userModel.birthdate = response.data.data.birthdate;
                    this.userModel.birthplace = response.data.data.birthplace;
                    this.userModel.nationalCode = response.data.data.nationalCode;
                    this.userModel.cellPhone1 = response.data.data.cellPhone1;
                    this.userModel.phone1 = response.data.data.phone1;
                    this.userModel.postalCode = response.data.data.postalCode;
                    this.userModel.address = response.data.data.address;
                    this.userModel.accountNumber = response.data.data.accountNumber;
                    this.userModel.shebaCode = response.data.data.shebaCode;
                    this.userModel.code = response.data.data.code;

                    // this.preselectedUserProvince.name = response.data.data.province;
                    // this.preselectedUserProvince.id = response.data.data.provinceId;
                    // this.preselectedUserCity.name = response.data.data.city;
                    // this.preselectedUserCity.id = response.data.data.cityId;
                    // if (response.data.data.male) {
                    //     this.preselectedUserGender.name = "مرد";
                    //     this.preselectedUserGender.value = true;
                    // } else {
                    //     this.preselectedUserGender.name = "زن";
                    //     this.preselectedUserGender.value = false;
                    // }
                    if (this.userModel.birthdate !== null) {
                        this.birthDay = Moment(this.gregorianToJalali(this.userModel.birthdate), 'jYYYY/jMM/jDD').format('jDD jMMMM jYYYY');
                    }
                }).catch(error => {
                    console.log(error);
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
            },
            // confirmUserData() {
            //     this.isLoading = true;
            //     new BaseService("User", "/GetUser").getList(this.userModel).then(response => {
            //         this.isLoading = false;
            //         // console.log(response.data)
            //         this.$noty.success('اطلاعات با موفقیت ثبت شد', {timeout: 1000})
            //     }).catch(error => {
            //         Utils.handleErrorWithNotification(error.data, this.$noty);
            //     });
            // },
            // getProvince() {
            //     this.isLoading = true;
            //     new BaseService("State", "/GetStates").getList().then(response => {
            //         this.isLoading = false;
            //         // console.log(response.data);
            //         this.province = response.data
            //     }).catch(error => {
            //         Utils.handleErrorWithNotification(error.data, this.$noty);
            //     });
            // },
            // getCities(id) {
            //     this.isLoading = true;
            //     new BaseService("State", `/GetCitiesOfState/${id}`).getList().then(response => {
            //         this.isLoading = false;
            //         // console.log(response.data)
            //         this.city = response.data;
            //     }).catch(error => {
            //         Utils.handleErrorWithNotification(error.data, this.$noty);
            //     });
            // },
            getProvince() {
                new BaseService("State", "/GetStates").getList().then(response => {
                    this.province = response.data

                }).catch(error => {
                });
            },
            getCities(id) {
                new BaseService("State", `/GetCitiesOfState/${id}`).getList().then(response => {
                    this.city = response.data;
                }).catch(error => {

                });
            },
            onCreateDatePicked(val) {
                this.birthDay = Moment(val, 'jYYYY/jMM/jDD').format('jDD jMMMM jYYYY');
                this.userModel.birthdate = this.jalaliToGregorian(val);
                /* let startDate = this.startPersianDate.split("/");
                 console.log(startDate);*/
            },
            toggleCreateDatePicker() {
                this.$refs.birthDay.togglePicker();
            },
            onProfileGenderChange(val) {
                if (val) {
                    this.userModel.male = val.value
                }
            },
            onProfileCityChange(val) {
                if (val) {
                    this.userModel.cityId = val.id;
                    this.userModel.city = val.name;
                } else {
                    // this.competitionCity = []
                }

            },
            onProfileProvinceChange(val) {
                console.log(val)
                if (val) {
                    this.userModel.provinceId = val.id;
                    this.userModel.province = val.name;
                    if (val.id !== undefined) {
                        this.getCities(val.id);
                    }
                } else {
                    this.city = []
                }
            },
            onProfileImageChange(e) {
                let files = e.target.files;
                let app = this;
                if (files && files[0]) {
                    this.newImageCliked = true;
                    for (let item of files) {
                        let extension = item.name.slice((item.name.lastIndexOf(".") - 1 >>> 0) + 2);
                        // if (extension === "jpg" || extension === "JPG" ||
                        //     extension === "png" || extension === "PNG" ||
                        //     extension === "JPEG" || extension === "jpeg") {
                        let reader = new FileReader();
                        reader.onload = function (e) {
                            // $("#bannerImg").attr("src", e.target.result);
                            let a = e.target.result;

                            app.userModel.userImage = a.substring(a.indexOf(',') + 1, a.length);
                            app.userModel.userNewImage = e.target.result;
                            app.userModel.extension = extension;
                        };
                        reader.readAsDataURL(item);
                        // } else {
                        //     alert("لطفا فایل عکس بارگذاری کنید");
                        // }
                    }
                }
            },
            submitUserForm() {
                // this.userModel.userImage = this.removeBase64Comma(this.userModel.userImage);
                this.isLoading = true;
                new BaseService("Profile").update(this.userModel).then(response => {
                    this.isLoading = false;
                    this.$noty.success("اطلاعات کاربر با موفقیت ویرایش شد");
                    this.$router.push({name: "home"});
                    // if (this.userModel.userImage !== "") {
                    //     new BaseService("User", "/GetUser").getList().then(response => {
                    //         EventBus.$emit("setProfileImage", this.validateImageUrl(response.data.userImage));
                    //     }).catch(error => {
                    //         Utils.handleErrorWithNotification(error.data, this.$noty);
                    //     }).then(() => {
                    //         this.$router.push({path: '/'});
                    //     });
                    // } else {
                    //     this.$router.push({path: '/'});
                    // }
                }).catch(error => {
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
            },
            validateProfilePlaceholder(img) {
                // let final = img.substr(img.lastIndexOf('/') + 1);
                // let file = final.split('.');
                // return "/img/" + file[0] + '.' + file[2];
            },
            onAddNetClicked() {
                this.netMode = "create";
                this.$refs.insertModal.showModal();
            },
            getMyNets() {
                new BaseService("user", "/GetSocialNetworks").getList().then(response => {
                    this.myNets = response.data;
                    for (let i of this.myNets) {
                        switch (i.type) {
                            case 1:
                                i.icon = this.netIcons[0].title;
                                i.name = this.netTypes[0].title;
                                break;
                            case 2:
                                i.icon = this.netIcons[1].title;
                                i.name = this.netTypes[1].title;
                                break;
                            case 3:
                                i.icon = this.netIcons[2].title;
                                i.name = this.netTypes[2].title;
                                break;
                            case 4:
                                i.icon = this.netIcons[3].title;
                                i.name = this.netTypes[3].title;
                                break;
                            case 5:
                                i.icon = this.netIcons[4].title;
                                i.name = this.netTypes[4].title;
                                break;
                            case 6:
                                i.icon = this.netIcons[5].title;
                                i.name = this.netTypes[5].title;
                                break;
                            case 7:
                                i.icon = this.netIcons[6].title;
                                i.name = this.netTypes[6].title;
                                break;
                            case 8:
                                i.icon = this.netIcons[7].title;
                                i.name = this.netTypes[7].title;
                                break;
                        }
                    }
                }).catch(error => {
                    console.log(error);
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
            },
            getnetTypes() {
                new BaseService("user", "/GetEnSocialNetworkType").getList().then(response => {
                    this.netTypes = response.data;

                }).catch(error => {
                    console.log(error);
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
            },
            getnetIcons() {
                new BaseService("user", "/GetEnSocialNetworkIcon").getList().then(response => {
                    this.netIcons = response.data;
                }).catch(error => {
                    console.log(error);
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
            },
            editItem(item) {
                this.model = item;
                this.netMode = "edit";
                this.$refs.insertModal.showModal();
            },
            deleteItem(item) {
                if (confirm("آیا از حذف این آیتم اطمینان دارید؟")) {
                    new BaseService("user", "/DeleteSocialNetworks").delete(item.id).then(response => {
                        this.$noty.warning("آیتم با موفقیت حذف شد");
                        this.getMyNets();
                    }).catch(error => {
                        Utils.handleErrorWithNotification(error.data, this.$noty);
                    })
                }
            },
            onNetTypeChange(val) {
                if (val) {
                    this.model.type = val.value
                }
            },
            updateNet() {
                new BaseService("user", "/UpdateSocialNetworks").update(this.model).then(response => {
                    this.$noty.success("شبکه اجتماعی با موفقیت ویرایش شد");
                    this.$refs.insertModal.hideModal();
                    this.getMyNets();
                }).catch(error => {
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                    this.$refs.insertModal.hideModal();
                    this.getMyNets();
                });

            },
            createNet() {
                new BaseService("user", "/CreateSocialNetworks").create(this.model).then(response => {
                    this.$noty.success("شبکه اجتماعی با موفقیت ثبت شد");
                    this.$refs.insertModal.hideModal();
                    this.getMyNets();
                }).catch(error => {
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                    this.$refs.insertModal.hideModal();
                    this.getMyNets();
                });
            },
            cancelNet() {
                this.$refs.insertModal.hideModal();
                this.getMyNets();
            },


        }
    }
</script>

<style lang="scss" scoped>
    .profile-image {
        margin: 0 auto 1rem auto;
    }

    .profile-image img {
        max-width: 150px;
        border-radius: 1rem;
        box-shadow: 0 10px 25px -10px rgba(0, 0, 0, 0.25);
    }
</style>